import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { trackById } from '@core/utils/utils';
import { Company } from '@models/company/company';
import { Publication } from '@models/company/publication';
import { Select, Store } from '@ngxs/store';
import { LoadMore } from '@store/company/news/news.actions';
import { NewsState } from '@store/company/news/news.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'company-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsComponent implements OnInit {
  @Select(NewsState.loading) loading$: Observable<boolean>;
  @Input() company: Company;

  publications$: Observable<Publication[]>;
  page$: Observable<number>;
  nbPages$: Observable<number>;
  trackById = trackById;

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.publications$ = this.store.select(NewsState.publications(this.company.id));
    this.page$ = this.store.select(NewsState.page(this.company.id));
    this.nbPages$ = this.store.select(NewsState.nbPages(this.company.id));
  }

  loadMore(): void {
    this.store.dispatch(new LoadMore(this.company.id));
  }
}
